$.extend({
    getFunction(code, argNames) {
        let fn = window;
        const parts = (code || '').split('.');
        while (fn && parts.length) {
            fn = fn[parts.shift()];
        }
        if (typeof (fn) === 'function') {
            return fn;
        }
        argNames.push(code);
        return Function.constructor.apply(null, argNames);
    },
    getIEVersion() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    },
    isDate(input) {
        const dateTest = new RegExp(/(?=\d)^(?:(?!(?:10\D(?:0?[5-9]|1[0-4])\D(?:1582))|(?:0?9\D(?:0?[3-9]|1[0-3])\D(?:1752)))((?:0?[13578]|1[02])|(?:0?[469]|11)(?!\/31)(?!-31)(?!\.31)|(?:0?2(?=.?(?:(?:29.(?!000[04]|(?:(?:1[^0-6]|[2468][^048]|[3579][^26])00))(?:(?:(?:\d\d)(?:[02468][048]|[13579][26])(?!\x20BC))|(?:00(?:42|3[0369]|2[147]|1[258]|09)\x20BC))))))|(?:0?2(?=.(?:(?:\d\D)|(?:[01]\d)|(?:2[0-8])))))([-.\/])(0?[1-9]|[12]\d|3[01])\2(?!0000)((?=(?:00(?:4[0-5]|[0-3]?\d)\x20BC)|(?:\d{4}(?!\x20BC)))\d{4}(?:\x20BC)?)(?:$|(?=\x20\d)\x20))?((?:(?:0?[1-9]|1[012])(?::[0-5]\d){0,2}(?:\x20[aApP][mM]))|(?:[01]\d|2[0-3])(?::[0-5]\d){1,2})?$/);
        return dateTest.test(input);
    }
});

// Allow CSS transitions when page is loaded
$(window).on('load', () => $('body').removeClass('no-transitions'));

function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

$(function () {

    // Disable CSS transitions on page load
    $('body').addClass('no-transitions');

    const ie = $.getIEVersion();
    if (ie === false) {
        // other browser
    } else {
        $('body').addClass(`ie ie-${ie}`);
    }

    // ========================================
    //
    // Content area height
    //
    // ========================================


    // Calculate min height
    function containerHeight() {
        const availableHeight = $(window).height() - $('.page-container').offset().top - $('.navbar-fixed-bottom').outerHeight();

        $('.page-container').attr('style', 'min-height:' + availableHeight + 'px');
    }

    // Initialize
    containerHeight();



    // ========================================
    //
    // Heading elements
    //
    // ========================================


    // Heading elements toggler
    // -------------------------

    // Add control button toggler to page and panel headers if have heading elements
    $('.panel-footer').has('> .heading-elements:not(.not-collapsible)').prepend('<a class="heading-elements-toggle"><i class="fa fa-ellipsis-v"></i></a>');
    $('.page-title, .panel-title').parent().has('> .heading-elements:not(.not-collapsible)').children('.page-title, .panel-title').append('<a class="heading-elements-toggle"><i class="fa fa-ellipsis-v"></i></a>');


    // Toggle visible state of heading elements
    $('.page-title .heading-elements-toggle, .panel-title .heading-elements-toggle').on('click', function () {
        $(this).parent().parent().toggleClass('has-visible-elements').children('.heading-elements').toggleClass('visible-elements');
    });
    $('.panel-footer .heading-elements-toggle').on('click', function () {
        $(this).parent().toggleClass('has-visible-elements').children('.heading-elements').toggleClass('visible-elements');
    });



    // Breadcrumb elements toggler
    // -------------------------

    // Add control button toggler to breadcrumbs if has elements
    $('.breadcrumb-line').has('.breadcrumb-elements').prepend('<a class="breadcrumb-elements-toggle"><i class="fa fa-arrows-v"></i></a>');


    // Toggle visible state of breadcrumb elements
    $('.breadcrumb-elements-toggle').on('click', function () {
        $(this).parent().children('.breadcrumb-elements').toggleClass('visible-elements');
    });




    // ========================================
    //
    // Navbar
    //
    // ========================================


    // Navbar navigation
    // -------------------------

    // Prevent dropdown from closing on click
    $(document).on('click', '.dropdown-content', (e) => e.stopPropagation());

    // Disabled links
    $('.navbar-nav .disabled a').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });

    // Show tabs inside dropdowns
    $('.dropdown-content a[data-toggle="tab"]').on('click', function () {
        $(this).tab('show');
    });

    $(document).on('click', '[data-dismiss=dropdown]', function () {
        const $dropdown = $(this).closest('.btn-group.open, .dropdown.open');

        if ($dropdown.length) {
            $dropdown.removeClass('open');
        }
    });

    // Prevent bootstrap-select inside dropdown-content to close content
    $('body').on('click', (e) => {
        const $target = $(e.target),
            $parent = $target.closest('.bootstrap-select'),
            $content = $parent.closest('.dropdown-content');

        if ($content.length) {
            if ($parent.length) {
                e.stopPropagation();
                if (!$parent.hasClass('open')) {
                    $('.bootstrap-select').removeClass('open');
                }
                $parent.toggleClass('open');
            } else {
                $('.bootstrap-select').removeClass('open');
            }
        } else if (!$parent.length) {
            $('.bootstrap-select').removeClass('open');
        }
    });

    let dropdown;
    $(document).on('show.bs.dropdown', '.table-responsive .dropdown, .table-responsive .btn-group', (e) => {
        const $target = $(e.target);
        const offset = $target.offset();

        dropdown = $target.children('.dropdown-menu');
        if (!dropdown.closest('.bootstrap-select,.dropdown-submenu').length) {
            $('body').append(dropdown.detach());

            if (dropdown.hasClass('dropdown-menu-right')) {
                dropdown.css({
                    display: 'block',
                    top: offset.top + $target.outerHeight(),
                    left: offset.left + $target.outerWidth() - dropdown.outerWidth(),
                    right: 'auto'
                });
            } else {
                dropdown.css({
                    display: 'block',
                    top: offset.top + $target.outerHeight(),
                    left: offset.left,
                    right: 'auto'
                });
            }
        }
    });
    $(document).on('hide.bs.dropdown', '.table-responsive .dropdown, .table-responsive .btn-group', (e) => {
        const $target = $(e.target);
        if (!$target.children('.dropdown-menu').closest('.bootstrap-select,.dropdown-submenu').length) {
            $target.append(dropdown.detach());
            dropdown.hide();
        }
    });

    // ========================================
    //
    // Element controls
    //
    // ========================================


    // Reload elements
    // -------------------------

    // Panels
    $('.panel [data-action=reload]').click(function (e) {
        e.preventDefault();
        const $block = $($(this).parent().parent().parent().parent().parent());
        $block.block({
            message: '<i class="fa fa-spinner spinner"></i>',
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: 0.8,
                cursor: 'wait',
                'box-shadow': '0 0 0 1px #ddd'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none'
            }
        });

        // For demo purposes
        window.setTimeout(() => $block.unblock(), 2000);
    });


    // Sidebar categories
    $('.category-title [data-action=reload]').click(function (e) {
        e.preventDefault();
        const $block = $($(this).parent().parent().parent().parent());
        $block.block({
            message: '<i class="fa fa-spinner spinner"></i>',
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.5,
                cursor: 'wait',
                'box-shadow': '0 0 0 1px #000'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none',
                color: '#fff'
            }
        });

        // For demo purposes
        window.setTimeout(() => $block.unblock(), 2000);
    });


    // Light sidebar categories
    $('.sidebar-default .category-title [data-action=reload]').click(function (e) {
        e.preventDefault();
        const $block = $($(this).parent().parent().parent().parent());
        $block.block({
            message: '<i class="fa fa-spinner spinner"></i>',
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: 0.8,
                cursor: 'wait',
                'box-shadow': '0 0 0 1px #ddd'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none'
            }
        });

        // For demo purposes
        window.setTimeout(() => $block.unblock(), 2000);
    });



    // Collapse elements
    // -------------------------

    //
    // Sidebar categories
    //

    // Hide if collapsed by default
    $('.category-collapsed').children('.category-content').hide();


    // Rotate icon if collapsed by default
    $('.category-collapsed').find('[data-action=collapse]').addClass('rotate-180');


    // Collapse on click
    $('.category-title [data-action=collapse]').click(function (e) {
        e.preventDefault();
        const $this = $(this);
        const $categoryCollapse = $this.parent().parent().parent().nextAll();
        $this.parents('.category-title').toggleClass('category-collapsed');
        $this.toggleClass('rotate-180');

        containerHeight(); // adjust page height

        $categoryCollapse.slideToggle(150);
    });


    //
    // Panels
    //

    // Hide if collapsed by default
    $('.panel-collapsed').children('.panel-heading').nextAll().hide();


    // Rotate icon if collapsed by default
    $('.panel-collapsed').find('[data-action=collapse]').addClass('rotate-180');


    // Collapse on click
    $('.panel [data-action=collapse]').click(function (e) {
        e.preventDefault();
        const $this = $(this);
        const $panelCollapse = $this.parent().parent().parent().parent().nextAll();
        $this.parents('.panel').toggleClass('panel-collapsed');
        $this.toggleClass('rotate-180');

      //  containerHeight(); // recalculate page height// this causes the scroll bar to apprear, 

        $panelCollapse.slideToggle(150);

        if (localStorage) {
            const collapsed = $this.hasClass('rotate-180'),
                name = $this.data('collapse-name');

            if (name) {
                localStorage.setItem(name, collapsed);
            }
        }
    });


    //wrapper for the existing Storage
    //function Storage() {
    //    this.get = function (name) {
    //       // return JSON.parse(window.localStorage.getItem(name));
    //        return window.localStorage.getItem(name);
    //    };

    //    this.set = function (name, value) {
    //        window.localStorage.setItem(name, JSON.stringify(value));
    //    };

    //    this.clear = function () {
    //        window.localStorage.clear();
    //    };
    //};

    ////collapse on click --> store the collapsed value to local storage
    //$('.panel [data-collapse-name]').click(function (e) {
    //    e.preventDefault();
    //    const $this = $(this),
    //        $name = $this.attr('data-collapse-name'); 

    //    var store = new Storage();
    //    var collapseObject = {};
    //    if ($this.parents('.panel').hasClass('panel-collapsed')) { 
    //        collapseObject = { name: $name, value: true };
    //         store.set($name, collapseObject);
    //    } else {
    //        collapseObject = { name: $name, value: false };
    //        store.set($name, collapseObject);
    //    }
    //});


    // Remove elements
    // -------------------------

    // Panels
    $('.panel [data-action=close]').click(function (e) {
        e.preventDefault();
        const $panelClose = $(this).parent().parent().parent().parent().parent();

        containerHeight(); // recalculate page height

        $panelClose.slideUp(150, function () {
            $(this).remove();
        });
    });


    // Sidebar categories
    $('.category-title [data-action=close]').click(function (e) {
        e.preventDefault();
        const $categoryClose = $(this).parent().parent().parent().parent();

        containerHeight(); // recalculate page height

        $categoryClose.slideUp(150, function () {
            $(this).remove();
        });
    });




    // ========================================
    //
    // Main navigation
    //
    // ========================================


    // Main navigation
    // -------------------------

    // Add 'active' class to parent list item in all levels
    $('.navigation').find('li.active').parents('li').addClass('active');

    // Hide all nested lists
    $('.navigation').find('li').not('.active, .category-title').has('ul').children('ul').addClass('hidden-ul');

    // Highlight children links
    $('.navigation').find('li').has('ul').children('a').addClass('has-ul');

    // Add active state to all dropdown parent levels
    $('.dropdown-menu:not(.dropdown-content), .dropdown-menu:not(.dropdown-content) .dropdown-submenu').has('li.active').addClass('active').parents('.navbar-nav .dropdown:not(.language-switch), .navbar-nav .dropup:not(.language-switch)').addClass('active');



    // Main navigation tooltips positioning
    // -------------------------

    // Left sidebar
    $('.navigation-main > .navigation-header > i').tooltip({
        placement: 'right',
        container: 'body'
    });



    // Collapsible functionality
    // -------------------------

    // Main navigation
    $('.navigation-main').find('li').has('ul').children('a').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);

        // Collapsible
        $this.parent('li').not('.disabled').not($('.sidebar-xs').not('.sidebar-xs-indicator').find('.navigation-main').children('li')).toggleClass('active').children('ul').slideToggle(250);

        // Accordion
        if ($('.navigation-main').hasClass('navigation-accordion')) {
            $this.parent('li').not('.disabled').not($('.sidebar-xs').not('.sidebar-xs-indicator').find('.navigation-main').children('li')).siblings(':has(.has-ul)').removeClass('active').children('ul').slideUp(250);
        }
    });


    // Alternate navigation
    $('.navigation-alt').find('li').has('ul').children('a').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);

        // Collapsible
        $this.parent('li').not('.disabled').toggleClass('active').children('ul').slideToggle(200);

        // Accordion
        if ($('.navigation-alt').hasClass('navigation-accordion')) {
            $this.parent('li').not('.disabled').siblings(':has(.has-ul)').removeClass('active').children('ul').slideUp(200);
        }
    });




    // ========================================
    //
    // Sidebars
    //
    // ========================================


    // Mini sidebar
    // -------------------------

    // Toggle mini sidebar
    $('.sidebar-main-toggle').on('click', (e) => {
        e.preventDefault();

        // Toggle min sidebar class
        $('body').toggleClass('sidebar-xs');
    });



    // Sidebar controls
    // -------------------------

    // Disable click in disabled navigation items
    $(document).on('click', '.navigation .disabled a', (e) => e.preventDefault());


    // Adjust page height on sidebar control button click
    $(document).on('click', '.sidebar-control', () => containerHeight());


    // Hide main sidebar in Dual Sidebar
    $(document).on('click', '.sidebar-main-hide', (e) => {
        e.preventDefault();
        $('body').toggleClass('sidebar-main-hidden');
    });


    // Toggle second sidebar in Dual Sidebar
    $(document).on('click', '.sidebar-secondary-hide', (e) => {
        e.preventDefault();
        $('body').toggleClass('sidebar-secondary-hidden');
    });


    // Hide all sidebars
    $(document).on('click', '.sidebar-all-hide', (e) => {
        e.preventDefault();
        $('body').toggleClass('sidebar-all-hidden');
    });



    //
    // Opposite sidebar
    //

    // Collapse main sidebar if opposite sidebar is visible
    $(document).on('click', '.sidebar-opposite-toggle', (e) => {
        e.preventDefault();
        const $body = $('body');

        // Opposite sidebar visibility
        $body.toggleClass('sidebar-opposite-visible');

        // If visible
        if ($body.hasClass('sidebar-opposite-visible')) {

            // Make main sidebar mini
            $body.addClass('sidebar-xs');

            // Hide children lists
            $('.navigation-main').children('li').children('ul').css('display', '');
        }
        else {
            // Make main sidebar default
            $body.removeClass('sidebar-xs');
        }
    });


    // Hide main sidebar if opposite sidebar is shown
    $(document).on('click', '.sidebar-opposite-main-hide', (e) => {
        e.preventDefault();
        const $body = $('body');

        // Opposite sidebar visibility
        $body.toggleClass('sidebar-opposite-visible');

        // If visible
        if ($body.hasClass('sidebar-opposite-visible')) {
            // Hide main sidebar
            $body.addClass('sidebar-main-hidden');
        }
        else {
            // Show main sidebar
            $body.removeClass('sidebar-main-hidden');
        }
    });


    // Hide secondary sidebar if opposite sidebar is shown
    $(document).on('click', '.sidebar-opposite-secondary-hide', (e) => {
        e.preventDefault();
        const $body = $('body');

        // Opposite sidebar visibility
        $body.toggleClass('sidebar-opposite-visible');

        // If visible
        if ($body.hasClass('sidebar-opposite-visible')) {
            // Hide secondary
            $body.addClass('sidebar-secondary-hidden');

        }
        else {
            // Show secondary
            $body.removeClass('sidebar-secondary-hidden');
        }
    });


    // Hide all sidebars if opposite sidebar is shown
    $(document).on('click', '.sidebar-opposite-hide', (e) => {
        e.preventDefault();
        const $body = $('body');

        // Toggle sidebars visibility
        $body.toggleClass('sidebar-all-hidden');

        // If hidden
        if ($body.hasClass('sidebar-all-hidden')) {
            // Show opposite
            $body.addClass('sidebar-opposite-visible');

            // Hide children lists
            $('.navigation-main').children('li').children('ul').css('display', '');
        }
        else {
            // Hide opposite
            $body.removeClass('sidebar-opposite-visible');
        }
    });


    // Keep the width of the main sidebar if opposite sidebar is visible
    $(document).on('click', '.sidebar-opposite-fix', (e) => {
        e.preventDefault();

        // Toggle opposite sidebar visibility
        $('body').toggleClass('sidebar-opposite-visible');
    });



    // Mobile sidebar controls
    // -------------------------

    // Toggle main sidebar
    $('.sidebar-mobile-main-toggle').on('click', (e) => {
        e.preventDefault();
        $('body').toggleClass('sidebar-mobile-main').removeClass('sidebar-mobile-secondary sidebar-mobile-opposite');
    });


    // Toggle secondary sidebar
    $('.sidebar-mobile-secondary-toggle').on('click', (e) => {
        e.preventDefault();
        $('body').toggleClass('sidebar-mobile-secondary').removeClass('sidebar-mobile-main sidebar-mobile-opposite');
    });


    // Toggle opposite sidebar
    $('.sidebar-mobile-opposite-toggle').on('click', (e) => {
        e.preventDefault();
        $('body').toggleClass('sidebar-mobile-opposite').removeClass('sidebar-mobile-main sidebar-mobile-secondary');
    });



    // Mobile sidebar setup
    // -------------------------

    $(window).on('resize', () => {
        setTimeout(() => {
            containerHeight();
            const $body = $('body');
            if ($(window).width() <= 768) {

                // Add mini sidebar indicator
                $body.addClass('sidebar-xs-indicator');

                // Place right sidebar before content
                $('.sidebar-opposite').prependTo('.page-content');

                // Add mouse events for dropdown submenus
                $('.dropdown-submenu').on('mouseenter', function () {
                    $(this).children('.dropdown-menu').addClass('show');
                }).on('mouseleave', function () {
                    $(this).children('.dropdown-menu').removeClass('show');
                });
            }
            else {

                // Remove mini sidebar indicator
                $body.removeClass('sidebar-xs-indicator');

                // Revert back right sidebar
                $('.sidebar-opposite').insertAfter('.content-wrapper');

                // Remove all mobile sidebar classes
                $body.removeClass('sidebar-mobile-main sidebar-mobile-secondary sidebar-mobile-opposite');

                // Remove visibility of heading elements on desktop
                $('.page-header-content, .panel-heading, .panel-footer').removeClass('has-visible-elements');
                $('.heading-elements').removeClass('visible-elements');

                // Disable appearance of dropdown submenus
                $('.dropdown-submenu').children('.dropdown-menu').removeClass('show');
            }
        }, 100);
    }).resize();




    // ========================================
    //
    // Other code
    //
    // ========================================


    // Plugins
    // -------------------------

    // Popover
    function popover() {
        $('.js-popover').each(function () {
            var $this = $(this),
                popoverCssClass = $this.data('popover-class'),
                titleCssClass = $this.data('title-class');
            if (popoverCssClass || titleCssClass) {
                $this.popover({
                    template: `<div class="popover ${popoverCssClass || ''}"><div class="arrow"></div><h3 class="popover-title ${titleCssClass || ''}"></h3><div class="popover-content"></div></div>`
                });
            } else {
                $this.popover();
            }
        });
    }

    // Tooltip
    function tooltip() {
        $('.js-tooltip').each(function () {
            var $this = $(this),
                cssClass = $this.data('class');
            if (cssClass) {
                $this.tooltip({
                    template: `<div class="tooltip" role="tooltip"><div class="${cssClass}"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div></div>`
                });
            } else {
                $this.tooltip();
            }
        });
    }

    popover();
    tooltip();

    $(document).ajaxStop(() => {
        popover();
        tooltip();
    });
});